import {useNotify} from "ra-core";
import {AutocompleteInput, ReferenceInput, ReferenceInputProps,} from "ra-ui-materialui";
import React from "react";
import {client} from "../../dataProvider";
import {generateError} from "../../shared/utils";

type ReferenceInputCustomerSubjectProps = Omit<
  ReferenceInputProps,
  "children" | "reference" | "sort"
>;

export const ReferenceInputCustomerSubject = (props: ReferenceInputCustomerSubjectProps) => {
  const notify = useNotify();
  const mustHaveProvince = async (subject_id: number | undefined) => {
    return undefined;
    if (subject_id) {
      return client(`customer_subjects/${subject_id}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.province && response.province.length === 2) {
            return undefined;
          } else {
            return "Il soggetto non ha la provincia";
          }
        })
        .catch((error) => {
          generateError(error, notify);
          return "Verificare che il soggetto abbia ha la provincia";
        });
    } else {
      return undefined;
    }
  };
  return (
    <ReferenceInput
      variant="outlined"
      {...(props as ReferenceInputProps)}
      reference="autocomplete/customer_subjects"
      sort={{ field: "business_name", order: "ASC" }}
      allowEmpty={true}
      validate={mustHaveProvince}
    >
      <AutocompleteInput
        optionText="label"
        onCreate={(filter) =>
          window.open(
            "/customer_subjects/create",
            "_blank" // <- This is what makes it open in a new window.
          )
        }
      />
    </ReferenceInput>
  );
};
